export default function GS_Sort_By_Range() {
  return (
    <div className="p-4">
      <h1>GS Sort By Range</h1>
    </div>
  );
}
